import CircleIcon from "@mui/icons-material/Circle";
import { Box, Button as MuiButton } from "@mui/material";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";

import { theme } from "../../mui-customs/Theme";
import { RootState } from "../../redux/store";
import Typography from "../Typography";

interface GigActivityCardProps {
  iconColor?: string;
  label: string;
}

const GigActivityCard = ({ iconColor, label }: GigActivityCardProps) => {
  const router = useRouter();
  const userUid = useSelector((state: RootState) => state.user.user.uid);
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
        py: 2,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <CircleIcon sx={{ color: iconColor, height: "12px", width: "12px" }} />
        <Typography variant="title2" sx={{ color: theme.grey2[500] }}>
          {label}
        </Typography>
      </Box>
      <MuiButton
        onClick={() => {
          router.push(`/gigs/${userUid}`);
        }}
        variant="text"
        sx={{
          textTransform: "none",
          color: theme.blue[400],
          height: "fit-content",
        }}
      >
        See all
      </MuiButton>
    </Box>
  );
};

export default GigActivityCard;
